module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [(_vm.showPagination) ? _c('ul', {
    staticClass: "pagination justify-content-end"
  }, [(_vm.pagination.first) ? _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.pagination.first)
      }
    }
  }, [_vm._v("«")])]) : _vm._e(), _vm._v(" "), (_vm.pagination.previous) ? _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.pagination.previous)
      }
    }
  }, [_vm._v("‹")])]) : _vm._e(), _vm._v(" "), (_vm.pagination.range[0] > _vm.pagination.first) ? _c('li', {
    staticClass: "page-item disabled d-none d-sm-flex",
    attrs: {
      "role": "separator"
    }
  }, [_c('span', {
    staticClass: "page-link"
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pagination.range), function(item, index) {
    return _c('li', {
      staticClass: "page-item",
      class: _vm.isCurrentPage(item)
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.changePage(item)
        }
      }
    }, [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), (_vm.pagination.range[_vm.pagination.range.length - 1] < _vm.pagination.last) ? _c('li', {
    staticClass: "page-item disabled d-none d-sm-flex",
    attrs: {
      "role": "separator"
    }
  }, [_c('span', {
    staticClass: "page-link"
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.pagination.next) ? _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.pagination.next)
      }
    }
  }, [_vm._v("›")])]) : _vm._e(), _vm._v(" "), (_vm.pagination.last) ? _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.pagination.last)
      }
    }
  }, [_vm._v("»")])]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4358abac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Pagination.vue
// module id = 810
// module chunks = 0